module.exports = __webpack_public_path__ + "static/media/Rotasi_Books.6e1a45a5.png";